import React from 'react';
import Select from './calendar_select';

export default class CalendarForm extends React.Component {

  constructor(props) {
    super(props);
    this.calendarState = props.calendarState;
  }

  render() {

    return (
      <form id="calendar-filters" className="events-list-form__filters" action="">
        <div className="events-list-form__filter-facet events-list-form__filter-facet--date">
          <label className="events-list-form__label">When</label>
          <div className="events-list-form__filter-select custom-select">
            <Select
              fieldName="dateRange"
              options={this.calendarState.form.choices.dateRanges}
              value={this.calendarState.form.data.dateRange}
              onChange={(value) => this.calendarState.form.onSelectFieldChange(this.calendarState.form, 'dateRange', value)}
              />
            <span className="custom-select__indicator">
              <span className="icon">
                <i className="fa-solid fa-chevron-down"></i>
              </span>
            </span>
          </div>
        </div>
        <div className="events-list-form__filter-facet events-list-formr__filter-facet--type">
          <label className="events-list-form__label">Event type</label>
          <div className="events-list-form__filter-select custom-select">
            <Select
              fieldName="eventCategory"
              options={this.calendarState.form.choices.eventCategories}
              value={this.calendarState.form.data.eventCategory}
              onChange={(value) => this.calendarState.form.onSelectFieldChange(this.calendarState.form, 'eventCategory', value)}
              />
            <span className="custom-select__indicator">
              <span className="icon">
                <i className="fa-solid fa-chevron-down"></i>
              </span>
            </span>
          </div>
        </div>
      </form>
    );
  }
}
